import { FC, PropsWithChildren } from 'react';
import styled from 'styled-components';

import { LinkButton, LinkButtonProps } from 'ui/linkButton';
import { BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button';
import { OpenNewWindow16 } from 'ui/icons';
import { ANALYTICS_VIEW_INSIGHTS_TEST_ID } from './WorkflowAnalytics.constants';

const StyledButton = styled(LinkButton)`
  display: inline-flex;
  align-items: center;
`;

export const InsightsButton: FC<PropsWithChildren<LinkButtonProps>> = ({ children, ...props }) => (
  <StyledButton
    data-test={ANALYTICS_VIEW_INSIGHTS_TEST_ID}
    variant={BUTTON_VARIANTS.SECONDARY}
    size={BUTTON_SIZES.MEDIUM}
    target="_blank"
    {...props}
  >
    <span>{children}</span>
    <OpenNewWindow16 />
  </StyledButton>
);
